import React from "react";
import { MapPin } from "lucide-react";
import { LogoMark } from "@/components/app/Logo";

export default function Header({ meta }) {
  return (
    <header className="sticky top-3 z-40 mx-auto max-w-[1600px] px-3 sm:px-4 lg:px-6">
      <div className="glass rounded-full px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 min-w-0">
          <LogoMark size={26} />
          <div className="hidden sm:block font-heading text-[10px] font-bold tracking-[0.28em] text-foreground/90">NAT HABITAT</div>
          <div className="h-4 w-px bg-border/60 mx-1" />
          <span className="font-heading text-sm font-bold truncate" data-testid="quotation-no">
            {meta?.["QUOTATION NO."] || "P2407-QTN-002-R1"}
          </span>
          <span className="hidden md:inline text-[11px] text-muted-foreground font-mono truncate max-w-xs ml-1">
            · {meta?.["PROJECT CODE"] || "P2407-NATASHA RAISI-JOINERY-HATTAN, THE LAKES"}
          </span>
        </div>
        <div className="flex items-center gap-2 text-[11px] text-muted-foreground shrink-0">
          <MapPin className="h-3 w-3" />
          <span className="font-mono uppercase tracking-wider">{meta?.LOCATION || "DUBAI, UAE"}</span>
          <span className="text-border">·</span>
          <span className="font-mono uppercase tracking-wider">CLIENT: {meta?.CLIENT || "NATASHA RAISI"}</span>
        </div>
      </div>
    </header>
  );
}
